// extracted by mini-css-extract-plugin
export default {"wrapper":"Ks-z","addressLine":"Ls-z","fullName":"Ms-z"};